import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { asocebuKeys } from '../queries/keys';
import { asocebuPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks de ASOCEBU (api-reference/admin-asocebu.md).
// El worklist agrupa transferencias por cruce (clivage); el ticket se asocia al cruce.

// Worklist de cruces. Filtros: session, from/to (fecha TE), has_ticket, limit/offset.
export function useCrosses(filters = {}) {
    return useQuery({
        queryKey: asocebuKeys.crosses(filters),
        queryFn:  ({ signal }) => api.get(asocebuPaths.crosses(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

// Asociar/actualizar el ticket de un cruce. El POST es FIND-OR-UPDATE por clivage
// (si el cruce ya tiene ticket activo, lo actualiza) → sirve para asignar Y editar.
export function useAssignTicket() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(asocebuPaths.tickets(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: asocebuKeys.all }),
    });
}

// Quitar ticket (soft-delete). El único es parcial → libera el clivage para re-asociar.
export function useDeleteTicket() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(asocebuPaths.ticketItem(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: asocebuKeys.all }),
    });
}
